/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'map': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" _fill="none" _stroke="currentColor" stroke-linecap="square" stroke-width="2" d="M3.757 11.243a6 6 0 118.486 0L8 15.485l-4.243-4.242zM8 9a2 2 0 100-4 2 2 0 000 4z"/>'
  }
})
